export default "__VITE_ASSET__DL8MrYGA__"